import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { AbstractSelectionService, FilterListComponent } from 'gung-list';
import {
  Product,
  ProductListComponent,
  ProductSelectionService
} from 'gung-standard';
import { OttoOlsenProductExportService } from "../../services/otto-olsen-product-export.service";
import { OttoOlsenProductAssortmentListConfigService } from '../../services/otto-olsen-product-assortment-list-config.service';

@Component({
  selector: 'otto-olsen-product-list-assortment',
  template: '<h2 class="text-center" translate>EXTRA_PRODUCTS</h2><div class="row"><div class="col-12"><button type="button" class="btn btn-primary float-right" (click)="exportToExcel()" translate>EXPORT_TO_EXCEL</button></div></div><lib-filter-list #productList [configService]="productListConfigService" [topFilter]="true"></lib-filter-list>',
  styleUrls: ['./otto-olsen-product-list-assortment.component.scss'],
  providers: [
    {
      provide: AbstractSelectionService,
      useClass: ProductSelectionService
    }
  ],
  standalone: false
})
export class OttoOlsenProductListAssortmentComponent extends ProductListComponent implements OnInit {
  public productListConfigService = inject(OttoOlsenProductAssortmentListConfigService);
  private ottoOlsenProductExportService = inject(OttoOlsenProductExportService);

  @ViewChild('productList') productList: FilterListComponent<Product>;

  exportToExcel() {
    this.ottoOlsenProductExportService.exportExcel(this.productList.items, "CUSTOMER-SPECIFIC-ASSORTMENT-EXPORT", null).subscribe(res => {

    })
  }
}
